import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisWordCloudChartResponseDto,
  IAnalysisWordCloudChartResultVo,
  IAnalysisWordCloudDataDto,
  TAnalysisWordCloudDataVo,
} from '../types';

import { isMissingWireArray, pickChartDisplayMeta } from './common';

/** WordCloud · `word_cloud` wire 是否无有效数据。 */
function isWordCloudWireNoData(
  dto: IAnalysisWordCloudDataDto | null | undefined,
): boolean {
  if (dto == null || typeof dto !== 'object') {
    return true;
  }

  return isMissingWireArray(dto.data);
}

/** WordCloud · `word_cloud` 同形透传；`null`/非对象兜底 `{}`。 */
function normalizeWordCloudData(
  value: IAnalysisWordCloudDataDto | null | undefined,
): TAnalysisWordCloudDataVo {
  if (value == null || typeof value !== 'object') {
    return {};
  }

  return value as TAnalysisWordCloudDataVo;
}

export function transformWordCloudChartResponseDtoToVo(
  dto: IAnalysisWordCloudChartResponseDto,
): IAnalysisWordCloudChartResultVo {
  const { word_cloud: wordCloudWire } = dto;
  const isNoData = isWordCloudWireNoData(wordCloudWire);

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.WordCloud,
    isNoData,
    ...(isNoData ? {} : { wordCloudData: normalizeWordCloudData(wordCloudWire) }),
  };
}
